<template>
	<section class="ctn">
		<header class="header left">
			<router-link class="paper-action" :to="{ path: `/users`}"><heim-icon icon="arrow-back"></heim-icon><span>{{ $t('back') }}</span></router-link>
			<router-link class="paper-action" :to="{ path: `/users/${user.id}/edit`}"><span>{{ $t('edit') }}</span><heim-icon icon="chevron-right"></heim-icon></router-link>
		</header>
		<main class="user-details">
			<section class="info">
				<heim-card>
					<main>
						<div class="row">
							<h1>{{ $t('user') }}</h1>
							<span></span>
						</div>
					</main>
				</heim-card>
				<heim-card class="monitoring">
					<main>
						<div class="row">
							<div class="details-row">
								<span>{{ user.name }}</span>
								<span class="badge">{{ user.email }}</span>
							</div>
						</div>
					</main>
				</heim-card>
        <heim-card>
					<main>
						<div class="row">
							<h1>{{$t('projects')}}</h1>
							<span></span>
						</div>
					</main>
				</heim-card>
				<heim-card class="monitoring">
					<main>
						<div class="row" v-for="project in projects" :key="`userProject-${project.id}`">
							<div class="details-row">
								<span><router-link :to="{ path: `/projects/${project.id}/details` }">{{ project.name }}</router-link></span>
								<span class="badge">{{ project.Status ? project.Status.name : "n/a"  }}</span>
							</div>
						</div>
					</main>
				</heim-card>
			</section>
		</main>
	</section>
</template>


<script>
import HeimIcon from "@/components/icon/heim-icon";
import HeimCard from "@/components/layout/card/heim-card.vue";
import { mapState } from "vuex";

export default {
  name: "UsersDetails",
  components: {
    HeimIcon,
    HeimCard
  },
  data() {
    return {
      options: {
        responsive: true,
        scales: {
          xAxes: [
            {
              type: "time",
              time: {
                // round: 'day'
                tooltipFormat: "ll HH:mm"
              },
              scaleLabel: {
                display: true,
                labelString: "Time"
              }
            }
          ],
          yAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: "value"
              }
            }
          ]
        }
      }
    };
  },
  mounted() {
    const id = this.$route.params.id;
    this.$store.dispatch("getUser", id);
    this.$store.dispatch("getUserInProject", id);
    this.$watch(
      vm => vm.user,
      val => {
        this.$store.dispatch("setTitle", `User - ${val.name}`);
      }
    );
  },
  computed: {
    ...mapState({
      user: state => state.usersState.user,
      projects: state => state.projectsState.userProject
    })
  },
  methods: {}
};
</script>

<style scoped>
.user-details,
.details-row {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap-reverse;
}
.details-row {
  width: 100%;
}

.details-row .badge {
  background-color: var(--heim-grey-color);
}

.user-details > .paper-card,
.user-details > .info {
  width: 100%;
  margin-right: 0;
}

.user-details .stats,
.user-details .monitoring {
  margin-bottom: 1em;
}

.info {
  display: flex;
  flex-direction: column;
}

.disabled {
  color: #8b969c;
}

.monitoring,
.site {
  margin-bottom: 1em;
}

.link {
  padding: 1em;
  border-bottom: 1px solid #eee;
}

.link:last-child {
  border: none;
}

.info .paper-card {
  border-radius: 3px 3px 0 0;
}

.paper-card.monitoring {
  border-radius: 0;
}
.details-row span:first-child {
  padding: 0.2rem 0;
}

/* Wide layout: when the viewport width is bigger than 460px, layout
changes to a wide layout. */
@media (min-width: 460px) {
  .user-details {
    flex-wrap: nowrap;
  }
  .user-details > .paper-card,
  .user-details > .info {
    width: 50%;
    margin-right: 1em;
    height: 100%;
  }
}
</style>
